import { ItemCommAdapters } from './';
import { parseResponse } from 'helpers/Api';

export default class ItemComm {
    adapter = null;
    productId = null;
    productType = null;

    setAdapter(Adapter) {
        this.adapter = new Adapter();
        return this;
    }

    setProductId(id) {
        this.productId = id;
        return this;
    }

    setProductType(productType) {
        this.productType = productType;
        return this;
    }

    getProductData() {
        return this.adapter.getProductData(this.productId, this.productType);
    }
}

export const fetchProductData = (id, type, adapterSettings) => {
    const itemComm = new ItemComm();
    const itemCommAdapter = adapterSettings.itemComm.adapter.name;

    itemComm.setProductId(id);
    itemComm.setProductType(type);
    itemComm.setAdapter(ItemCommAdapters[itemCommAdapter]);

    return itemComm.getProductData()
        .then(parseResponse);
};
